import useGetTMSUserIdByEmail from '@/hooks/useGetTMSUserIdByEmail';
import { IUserProfileData } from '@/interfaces/profile.interface';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

interface IEnterpriseProfileDataContext {
  data: IUserProfileData | undefined;
  setData: Dispatch<SetStateAction<IUserProfileData | undefined>>;
  initData: IUserProfileData | undefined;
  enterpriseUserTmsId: string | undefined;
}

export const EnterpriseProfileDataContext =
  createContext<IEnterpriseProfileDataContext>({
    data: undefined,
    setData: () => undefined,
    initData: undefined,
    enterpriseUserTmsId: '',
  });

export const EnterpriseProfileDataProvider = ({
  initData,
  children,
}: {
  initData: IUserProfileData;
  children: ReactNode;
}) => {
  const enterpriseUserEmail = initData?.profiles.qbankData.email;
  const {
    queryReturn: { data: enterpriseUserTmsId },
  } = useGetTMSUserIdByEmail(enterpriseUserEmail || '');
  const [data, setData] = useState<IUserProfileData | undefined>(initData);

  return (
    <EnterpriseProfileDataContext.Provider
      value={{ data, setData, initData, enterpriseUserTmsId }}
    >
      {children}
    </EnterpriseProfileDataContext.Provider>
  );
};
